export const Money2 = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.16797 5.5H3.83464M12.168 10.5H12.8346M1.16797 11.1667V4.83333C1.16797 4.09695 1.76492 3.5 2.5013 3.5H13.5013C14.2377 3.5 14.8346 4.09695 14.8346 4.83333V11.1667C14.8346 11.903 14.2377 12.5 13.5013 12.5H2.5013C1.76492 12.5 1.16797 11.903 1.16797 11.1667ZM9.33463 8C9.33463 8.73638 8.73768 9.33333 8.0013 9.33333C7.26492 9.33333 6.66797 8.73638 6.66797 8C6.66797 7.26362 7.26492 6.66667 8.0013 6.66667C8.73768 6.66667 9.33463 7.26362 9.33463 8Z"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
